module.exports = __webpack_public_path__ + "static/media/avatar-1.5c1b333a.png";